module.exports = __webpack_public_path__ + "static/media/home_8.d692d6df.jpg";